import { Form, message } from 'antd';
import React, { useEffect, useState } from 'react';

import DefaultInput from 'components/input/DefaultInput';
import DefaultSelect from 'components/select/DefaultSelect';
import DropZoneImage from 'components/dropzoneUpload/DropZoneImage';
import SmallModal from 'components/form/SmallModal';
import SubmitButton from 'components/button/SubmitButton';
import VerticalForm from 'components/form/DefaultForm';
import { platformImageRegister } from 'apis/operation/platformImageApis';
import { useCookies } from 'react-cookie';
import { useTranslation } from 'react-i18next';

/**
 *
 * @param {*} props
 * @returns {플랫폼 이미지(공용 이미지) 등록 모달}
 */
const PlatformImgRegisterModal = ({
  visible,
  setVisible,
  fetchData,
  optionList,
  selectDesignType,
  setSelectDesignType,
}) => {
  const { t } = useTranslation();
  const [cookies] = useCookies();
  const [inputDatas, setInputDatas] = useState({
    image_name: '',
    design_type: '',
  });
  const [file, setFile] = useState(null);
  const [form] = Form.useForm();

  const handleClose = () => {
    setVisible(false);
    setInputDatas({ ...inputDatas, image_name: '', design_type: 'notice' });
    setFile(null);
    form.resetFields();
  };

  /// 이미지 타입 드롭다운 이벤트
  const handleChangeDesignType = (value) => {
    setInputDatas({ ...inputDatas, design_type: value });
  };
  /// 이미지명 입력
  const handleInputName = (e) => {
    setInputDatas({ ...inputDatas, image_name: e.target.value });
  };
  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append('uploadFile', file);
    formData.append('image_name', inputDatas.image_name);
    formData.append('design_type', inputDatas.design_type);

    const res = await platformImageRegister(formData);
    console.log(res);
    // 목록 화면의 디자인 타입 셀렉 박스 값을 반영시키기 위해 파라미터를 보낸다.
    fetchData(inputDatas.design_type);
    setSelectDesignType(inputDatas.design_type);
    setInputDatas({
      ...inputDatas,
      image_name: '',
      design_type: selectDesignType,
    });
    setFile(null);
    form.resetFields(); // 드롭존 이미지를 비우기 위해 필요하다.
    setVisible(false);
    message.success(t('platformimg.createImageTypeModal.successMessage'), 1);
  };
  useEffect(() => {
    if (selectDesignType) {
      setInputDatas({ ...inputDatas, design_type: selectDesignType });
    }
  }, []);
  return (
    <SmallModal
      title={t('platformimg.createImageTypeModal.title')}
      visible={visible}
      onCancel={handleClose}
    >
      <VerticalForm form={form} drop>
        <Form.Item label={t('platformimg.createImageTypeModal.imageType')}>
          <DefaultSelect
            optionList={optionList}
            value={inputDatas.design_type}
            onChange={handleChangeDesignType}
          />
        </Form.Item>
        <Form.Item label={t('platformimg.createImageTypeModal.imageName')}>
          <DefaultInput
            maxLength={35}
            value={inputDatas.image_name}
            onChange={handleInputName}
          />
        </Form.Item>
        <Form.Item name='uploadFile'>
          <DropZoneImage setFile={setFile} width={1620} height={1920} />
        </Form.Item>
        <SubmitButton onClick={handleSubmit}>
          {t('platformimg.createImageTypeModal.register')}
        </SubmitButton>
      </VerticalForm>
    </SmallModal>
  );
};

export default PlatformImgRegisterModal;
